import React, { useEffect, useState } from "react";
import { Card } from "../../components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import CommonPagination from "../../components/widgets/common_pagination";
import { CommonTextField } from "../../components/widgets/common_textField";
import AuthService from "../../service/auth.service";
import { toastError } from "../../common/toastNotification";
import moment from "moment";

const User = () => {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  const handleDataSize = (value) => {
    setSize(value);
    setPage(1);
  };

  const getUser = async () => {
    try {
      const response = await AuthService.getUser(
        "expert_consultations",
        page,
        size,
        search
      );

      setData(response?.data?.apiresponse?.data);
    } catch (error) {
      toastError(error || "Something went wrong");
    }
  };

  // Fetch data with debounce for search and pagination
  useEffect(() => {
    const handler = setTimeout(() => {
      getUser();
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [page, size, search]);

  return (
    <Card className="p-10 grid gap-6">
      <h3 className="text-xl tab:text-2xl font-bold">Booking List</h3>

      <div className="flex items-center justify-between gap-4 max-lg:flex-col">
        <div className="lg:max-w-72 w-full grid gap-1">
          <CommonTextField
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            placeholder="Search"
            className="w-full"
          />
        </div>    
      </div>

      <Table className="whitespace-nowrap">
        <TableHeader>
          <TableRow>
            <TableHead className="w-14">No</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Phone Number</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Meeting Date</TableHead>
            <TableHead>Meeting Time</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data?.users?.length > 0 ? (
            data?.users?.map((item, index) => (
              <TableRow key={item._id || index}>
                <TableCell className="ps-4">
                  {(page - 1) * size + index + 1}
                </TableCell>

                <TableCell>{item.name + " " + item.lastName || "-"}</TableCell>
                <TableCell>{item.email || "-"}</TableCell>
                <TableCell>{item.phoneNumber || "-"}</TableCell>
                <TableCell>{item.description || "-"}</TableCell>
                <TableCell>
                  {moment(item.date).format("DD/MM/YYYY") || "-"}
                </TableCell>
                <TableCell>
                  {moment(item.time).format("hh:mm A") || "-"}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow className="h-40">
              <TableCell
                colSpan={8}
                className="text-center text-black/50 font-medium text-xl"
              >
                No Users Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <div className="flex items-center justify-between max-md:flex-col gap-4">
        {data.totalPages > 1 && (
          <CommonPagination
            currentPage={data?.currentPage}
            totalPages={data?.totalPages}
            onPageChange={(newPage) => setPage(newPage)}
            pageSize={size}
            onPageSizeChange={handleDataSize}
          />
        )}
      </div>
    </Card>
  );
};

export default User;
